export default function sortBySortOrder(items) {
  return [...(items ?? [])].sort((a, b) => {
    const aOrder = Number(a?.sortOrder);
    const bOrder = Number(b?.sortOrder);
    const aHasOrder = Number.isFinite(aOrder);
    const bHasOrder = Number.isFinite(bOrder);

    if (aHasOrder && bHasOrder && aOrder !== bOrder) {
      return aOrder - bOrder;
    }

    if (aHasOrder !== bHasOrder) {
      return aHasOrder ? -1 : 1;
    }

    return 0;
  });
}